<mat-card></mat-card>
<mat-card-header>
    <div class="col-lg-10">
        <mat-card-title>
            Queued
        </mat-card-title>
    </div>
    <div class="col-lg-2">
        <div *ngIf="workflows.length > 0" class="margin-top-md">
            <button mat-button [matMenuTriggerFor]="tableControlMenu" class="pull-right">
                <mat-icon>menu</mat-icon>
            </button>
            <mat-menu #tableControlMenu="matMenu">
                <button mat-menu-item (click)="expandAll()">
                    <span>
                        Expand All
                    </span>
                </button>
                <button mat-menu-item (click)="collapseAll()">
                    <span>
                        Collapse All
                    </span>
                </button> 
            </mat-menu>
        </div>
    </div>
</mat-card-header>
<mat-divider></mat-divider>

<div class="row" style="margin-top:5px;">
    <div *ngFor="let workflow of workflows" class="margin-left-md">
        <h3>
            <span>
                <span *ngIf="!isLoading(workflow.ID) && workflow.states" class="badge">{{getWorkflowNodeCount(workflow)}}</span>
                <span *ngIf="!isLoading(workflow.ID) && !workflow.states" class="badge">X</span>
                <span *ngIf="isLoading(workflow.ID)" class="badge"><i class="fa fa-refresh fa-spin"></i></span>
            </span>&nbsp;
            <span class="cursor-pointer" (click)="toggleShow(workflow)">{{workflow.NAME}}</span>
            <mat-icon class="v-align-middle cursor-pointer" [color]="workflow.SHOW ? 'primary' : ''"
                (click)="toggleShow(workflow)">
                {{workflow.SHOW ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
        </h3>
        <div *ngFor="let state of workflow.states; let i = index" [hidden]="!workflow.SHOW"
            class="margin-left-md margin-bottom-sm">
            <h2>
                <span>
                    <span *ngIf="!isLoading(workflow.ID) && workflow.states" class="badge">{{state.NODES.length}}</span>
                    <span *ngIf="!isLoading(workflow.ID) && !workflow.states" class="badge">X</span>
                    <span *ngIf="isLoading(workflow.ID)" class="badge"><i class="fa fa-refresh fa-spin"></i></span>
                </span>&nbsp;
                <span class="cursor-pointer" (click)="toggleShow(state);">{{state.DESCRIPTION}}</span>
                <mat-icon class="v-align-middle cursor-pointer" [color]="state.SHOW ? 'primary' : ''"
                    (click)="toggleShow(state)">
                    {{state.SHOW ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </h2>
            <div [hidden]="!state.SHOW">
                <app-mat-table-queue [dataSource]="state.NODES" [WorkflowID]="workflow.ID" [workflow]="workflow" [state]="state" [no-reload]="true" [screenName]="scrName"></app-mat-table-queue>
            </div>
        </div>
    </div>
</div>
 <!--div class="row" style="margin-top: 15px;" class="margin-top-sm table-responsive">
    <div class="col">
        <div *ngFor="let workflow of workflows" class="margin-left-md">
            <h3>
                <div style="transform: translateY(18px);" matBadge="{{getWorkflowNodeCount(workflow)}}"
                    matBadgePosition="before" matBadgeOverlap="false"></div>
                &nbsp;&nbsp;<span class="cursor-pointer" (click)="toggleShow(workflow)">{{workflow.NAME}}</span>
                <mat-icon class="v-align-middle cursor-pointer" [color]="workflow.SHOW ? 'primary' : ''"
                    (click)="toggleShow(workflow)">
                    {{workflow.SHOW ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
            </h3>
            <div *ngFor="let state of workflow.states; let i = index" [hidden]="!workflow.SHOW"
                class="margin-left-md margin-bottom-sm">
                <h2>
                    <div style="transform: translateY(18px);" matBadge="{{state.NODES.length}}"
                        matBadgePosition="before" matBadgeOverlap="false"></div>
                    &nbsp;&nbsp;<span class="cursor-pointer" (click)="toggleShow(state);">{{state.DESCRIPTION}}</span>
                    <mat-icon class="v-align-middle cursor-pointer" [color]="state.SHOW ? 'primary' : ''"
                        (click)="toggleShow(state)">
                        {{state.SHOW ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                </h2>
                <div [hidden]="!state.SHOW">
                    <app-mat-table-queue [dataSource]="state.NODES" [WorkflowID]="workflow.ID"></app-mat-table-queue>
                </div>
            </div>
        </div>
    </div>
</div-->